/**
 *
 * @param {Map<String, any>} activeParent
 * @param {PropertyValueProps} property
 * @param {String} fn
 * @returns {Map<"order" | "path" | "priority", any>}
 */
const getOrderAndActiveParent = (activeParent, property, fn) => {
  const map = new Map();

  if (!activeParent) {
    const order = property.get("o_order") || 0;

    map.set("order", order);
    map.set("path", null);
    map.set("priority", "");

    return map;
  }

  let priority = "";

  /** Named (`transform`) or default (`0`) function */
  const activeFn = activeParent.get(fn);

  if (!activeFn) {
    map.set("order", 0);
    map.set("path", null);
    map.set("priority", "");

    return map;
  }

  /** Path of active property */
  const path = activeFn[0];

  /** Transform property order */
  const order = activeFn[3];

  /** If priority (`activeFn[1]`) and status running (`activeFn[2]`) */
  if (activeFn[1] && activeFn[2]) {
    priority = "important";
  }

  map.set("order", order);
  map.set("path", path);
  map.set("priority", priority);

  return map;
};

export default getOrderAndActiveParent;
